export const speiseplan = {    
    periode:  "19.10. - 23.10.2026",
    
    zusatz:  "11:30 Uhr - 13:30 Uhr",

    montag: {
        sichtbar: true,
        gericht: "Tagessuppe",
        beigabe: "",
        preis: "7,00 €"
    },

    dienstag: {
        sichtbar: true,
        gericht: "Hackfleisch-",
        beigabe: "Lauchsuppe",
        preis: "8,90 €"
    },


    mittwoch: {
        sichtbar: true,
        gericht: "Wurstgulasch mit",
        beigabe: "Nudeln",                                   
        preis: "9,90 €"
    },

    donnerstag: {
        sichtbar: true,
        gericht: "Hähnchenfilet mit Gemüse",
        beigabe: "dazu Kartoffeln",
        preis: "10,90"
    },

    freitag: {
        sichtbar: true,
        gericht: "Tagessuppe",
        beigabe: "",
        preis: "7,00 €"
    },
};
